import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var fetchMessagesForLocale = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    var messages, parentLocale, _messages;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return import( /* webpackChunkName: "@atlaskit-internal_browser-storage-controls" */"../../../i18n/".concat(locale));
        case 3:
          messages = _context.sent;
          return _context.abrupt("return", messages.default);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
        case 9:
          _context.prev = 9;
          parentLocale = locale.split(/[-_]/)[0];
          _context.next = 13;
          return import( /* webpackChunkName: "@atlaskit-internal_browser-storage-controls" */"../../../i18n/".concat(parentLocale));
        case 13:
          _messages = _context.sent;
          return _context.abrupt("return", _messages.default);
        case 17:
          _context.prev = 17;
          _context.t1 = _context["catch"](9);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7], [9, 17]]);
  }));
  return function fetchMessagesForLocale(_x) {
    return _ref.apply(this, arguments);
  };
}();